module.exports = __webpack_public_path__ + "img/logo-merta.55679af8.png";